<template>
  <div class="right-box-flex">
    <table class="right-box">
      <tbody>
        <!-- Section 1 -->
        <tr>
          <td data-cy="equipment-length-data">
            <h4>Equipment Length</h4>
            {{
              format(
                sagdMode
                  ? convert(
                      scenarioCalculations.equipmentLengths
                        ?.equipmentLengthSAGDFt.value,
                      LengthUnits.Feet,
                      getLargeLengthUnit("Equipment Length.convert.Feet").value
                    )
                  : convert(
                      scenarioCalculations.equipmentLengths?.equipmentLengthFt
                        .value,
                      LengthUnits.Feet,
                      getLargeLengthUnit("Equipment Length.convert.Feet").value
                    )
              )
            }}
            {{
              getLargeLengthUnit("Equipment Length.convert.Feet").value
                ?.shortLabel
            }}
          </td>
        </tr>
        <!-- <tr v-if="!scenario.equipment?.use_uphole_y_tool">
          <td data-cy="tubing-length-data">
            <h4>Tubing Length</h4>
            {{
              format(
                convert(
                  scenarioCalculations.equipmentLengths.tubingLengthFt.value,
                  LengthUnits.Feet,
                  getLargeLengthUnit("Top Tubing Length.write.Feet").value
                )
              )
            }}
            {{
              getLargeLengthUnit("Top Tubing Length.write.Feet").value
                ?.shortLabel
            }}
          </td>
        </tr> -->
        <tr>
          <td data-cy="bottom-of-equipment-md-data">
            <h4>Bottom of Equipment MD</h4>
            {{
              format(
                convert(
                  scenarioCalculations.equipmentLengths.bottomOfEquipmentDepthFt
                    .value,
                  LengthUnits.Feet,
                  getLargeLengthUnit("Equipment Length.convert.Feet").value
                )
              )
            }}
            {{
              getLargeLengthUnit("Equipment Length.convert.Feet").value
                ?.shortLabel
            }}
          </td>
        </tr>
        <tr v-if="scenario.equipment?.use_uphole_y_tool">
          <td data-cy="bottom-of-bypass-tubing-md-data">
            <h4>Bottom of Bypass Tubing MD</h4>
            {{
              format(
                convert(
                  scenarioCalculations.equipmentLengths.yToolBypassTubingDepthFt
                    .value,
                  LengthUnits.Feet,
                  getLargeLengthUnit("Equipment Length.convert.Feet").value
                )
              )
            }}
            {{
              getLargeLengthUnit("Equipment Length.convert.Feet").value
                ?.shortLabel
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="tubing-pressure-data">
            <h4>Tubing Pressure</h4>
            {{
              format(
                convert(
                  scenarioCalculations.basicData.value.bottomTubingPressurePSIA,
                  PressureUnits.PoundsPerSquareInchAbsolute,
                  getPressureUnit("Tubing Pressure.write.PSIA").value
                )
              )
            }}
            {{
              getPressureUnit("Tubing Pressure.write.PSIA").value?.shortLabel
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="casing-pressure-data">
            <h4>Casing Pressure</h4>
            {{
              format(
                convert(
                  scenario.parameters?.bottom_casing_pressure_psia,
                  PressureUnits.PoundsPerSquareInchAbsolute,
                  getPressureUnit("Casing Pressure.write.PSIA").value
                )
              )
            }}
            {{
              getPressureUnit("Casing Pressure.write.PSIA").value?.shortLabel
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="fluid-level-md-data">
            <h4>Liquid Above Pump (MD)</h4>
            {{
              `${format(
                convert(
                  scenarioCalculations.intakeCalculations.aggregate
                    .liquidAbovePumpMDFt.value,
                  LengthUnits.Feet,
                  getLargeLengthUnit("Liquid Above Pump (MD).convert.Feet")
                    .value
                )
              )} ${
                getLargeLengthUnit("Liquid Above Pump (MD).convert.Feet").value
                  ?.shortLabel
              }`
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="discharge-pressure-data">
            <h4>Discharge Pressure</h4>
            {{
              format(
                convert(
                  scenarioCalculations.pumpCalculations.aggregate
                    .producedDischargePressurePSIA.value,
                  PressureUnits.PoundsPerSquareInchAbsolute,
                  getPressureUnit("Produced Discharge Pressure.convert.PSIA")
                    .value
                )
              )
            }}
            {{
              getPressureUnit("Produced Discharge Pressure.convert.PSIA").value
                ?.shortLabel
            }}
          </td>
        </tr>

        <!-- Section 2 -->
        <tr>
          <td data-cy="total-dynamic-head-data">
            <h4>Total Dynamic Head (TDH)</h4>
            {{
              format(
                convert(
                  scenarioCalculations.pumpCalculations.aggregate
                    .producedTotalDynamicHeadFt.value,
                  LengthUnits.Feet,
                  getLargeLengthUnit("Produced TDH.convert.Feet").value
                )
              )
            }}
            {{
              getLargeLengthUnit("Produced TDH.convert.Feet").value?.shortLabel
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="pump-intake-pressure-data">
            <h4>Pump Intake Pressure (PIP)</h4>
            {{
              format(
                convert(
                  scenarioCalculations.pumpIntakePressurePSIA.value,
                  PressureUnits.PoundsPerSquareInchAbsolute,
                  getPressureUnit("Pump Intake Pressure.convert.PSIA").value
                )
              )
            }}
            {{
              getPressureUnit("Pump Intake Pressure.convert.PSIA").value
                ?.shortLabel
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="free-gas-into-pump-data">
            <h4>Free Gas into Pump</h4>
            {{
              format(
                convert(
                  scenarioCalculations.fluidProperties
                    .fluidPropertiesAfterAllGasSeparationAtPump.value
                    .gasFlowVolumeRatio,
                  PercentageUnits.Ratio,
                  PercentageUnits.Percentage
                )
              )
            }}
            {{ PercentageUnits.Percentage.shortLabel }}
          </td>
        </tr>
        <tr>
          <td data-cy="intake-depth-md-data">
            <h4>Intake Depth MD (PSD)</h4>
            {{
              format(
                convert(
                  scenarioCalculations.equipmentLengths.bottomOfIntakesDepthFt
                    .value,
                  LengthUnits.Feet,
                  getLargeLengthUnit("Equipment Length.convert.Feet").value
                )
              )
            }}
            {{
              getLargeLengthUnit("Equipment Length.convert.Feet").value
                ?.shortLabel
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="intake-depth-tvd-data">
            <h4>Intake Depth (TVD)</h4>
            {{
              format(
                convert(
                  scenarioCalculations.equipmentLengths.bottomOfIntakesTVDFt
                    .value,
                  LengthUnits.Feet,
                  getLargeLengthUnit("Equipment Length.convert.Feet").value
                )
              )
            }}
            {{
              getLargeLengthUnit("Equipment Length.convert.Feet").value
                ?.shortLabel
            }}
          </td>
        </tr>

        <!-- Section 3 -->
        <tr>
          <td data-cy="motor-hp-data">
            <h4>
              Motor HP @
              {{ format(scenarioCalculations.adjustedPumpHzFrequency.value) }}
              hz
            </h4>
            {{
              format(
                scenarioCalculations.motorCalculations.totalRequiredBrakeHP
                  .value
              )
            }}
            {{ PowerUnits.HorsePower.label }}
          </td>
        </tr>
        <tr>
          <td data-cy="motor-voltage-data">
            <h4>Motor Voltage</h4>
            {{
              format(
                convert(
                  scenarioCalculations.motorCalculations.motorVoltageV.value,
                  VoltageUnits.Volts,
                  getVoltageUnit("Total Voltage.convert.V").value
                )
              )
            }}
            {{
              getVoltageUnit("Total Voltage.convert.V").value?.shortLabel ||
              VoltageUnits.Volts.shortLabel
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="motor-amperage-data">
            <h4>Motor Amperage</h4>
            {{
              format(
                convert(
                  scenarioCalculations.motorCalculations.motorCurrentA.value,
                  CurrentUnits.Amperes,
                  getCurrentUnit("Motor Current.convert.A").value
                )
              )
            }}
            {{ getCurrentUnit("Motor Current.convert.A").value?.shortLabel }}
          </td>
        </tr>
        <tr>
          <td data-cy="flow-by-motor-data">
            <h4>Flow By Motor</h4>
            {{
              format(
                convert(
                  scenarioCalculations.motorCalculations
                    .flowVelocityAroundMotorFTSEC.value,
                  SpeedUnits.FeetPerSecond,
                  getSpeedUnit("Flow by Motor.convert.ft/s").value
                )
              )
            }}
            {{ getSpeedUnit("Flow by Motor.convert.ft/s").value?.shortLabel }}
          </td>
        </tr>

        <!-- Section 4 -->
        <tr>
          <td data-cy="sensor-pressure-data">
            <h4>Sensor Pressure</h4>
            {{
              format(
                convert(
                  scenarioCalculations.wellFlowingPressureAtSensorPSIA.value,
                  PressureUnits.PoundsPerSquareInchAbsolute,
                  getPressureUnit(
                    "Producing Bottomhole Pressure at Datum [Pwf].write.PSIA"
                  ).value
                )
              )
            }}
            {{
              getPressureUnit(
                "Producing Bottomhole Pressure at Datum [Pwf].write.PSIA"
              ).value?.shortLabel
            }}
          </td>
        </tr>
        <tr>
          <td data-cy="perf-pressure-data">
            <h4>Perf Pressure</h4>
            {{
              format(
                convert(
                  scenarioCalculations.wellFlowingPressureAtPerfsPSIA.value,
                  PressureUnits.PoundsPerSquareInchAbsolute,
                  getPressureUnit("Well Flowing Pressure (Perfs).convert.PSIA")
                    .value
                )
              )
            }}
            {{
              getPressureUnit("Well Flowing Pressure (Perfs).convert.PSIA")
                .value?.shortLabel
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import type { Scenario } from "@/composables/forms/formTypes";
import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import { useScenarioUnits } from "@/composables/units/useScenarioUnits";
import { convert } from "@/libs/units";
import { CurrentUnits } from "@/libs/units/current";
import { LengthUnits } from "@/libs/units/length";
import { PercentageUnits } from "@/libs/units/percentage";
import { PowerUnits } from "@/libs/units/power";
import { PressureUnits } from "@/libs/units/pressure";
import { VoltageUnits } from "@/libs/units/voltage";
import { SpeedUnits } from "@/libs/units/speed";
import { toRefs } from "vue";
import { useSettingsStore } from "@/store";
import { sizingKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { injectStrict } from "@/utils/utils";

const props = defineProps<{
  scenario: Scenario;
  scenarioCalculations: ScenarioCalculations;
  sagdMode?: boolean;
}>();
const { userSettingsNumberFormat } = useSettingsStore();

const format = Intl.NumberFormat(userSettingsNumberFormat.value, {
  maximumFractionDigits: 2
}).format;

const { scenario } = toRefs(props);
const sizing = injectStrict(sizingKey, null);
const {
  getLargeLengthUnit,
  getPressureUnit,
  getVoltageUnit,
  getCurrentUnit,
  getSpeedUnit
} = useScenarioUnits(scenario, sizing);
</script>
